export enum DialogMode {
  Create = 'create',
  Edit = 'edit',
}
